import React from 'react';
import AdminLayout from '../../components/AdminLayout';
import UserManager from '../../components/UserManager';

const AdminUsers = () => {
  return (
    <AdminLayout title="Gestion des utilisateurs">
      <UserManager />
    </AdminLayout>
  );
};

export default AdminUsers;